module.exports = __webpack_public_path__ + "img/logo.06ad92e8.png";